import { RawContextKey } from '../../../../platform/contextkey/common/contextkey.js';
const CommentsViewFilterFocusContextKey = ( new RawContextKey('commentsFilterFocus', false));
export { CommentsViewFilterFocusContextKey };
